import WorldMap from "$root/assets/images/hmm[preload]/WorldMap.svg";
import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { toClassName } from "@mdotm/shadcn/legacy/react-extensions";

export function WorldMapSvg({ className, style }: StylableProps): React.JSX.Element {
	return <img alt="world map" className={toClassName(className)} style={style} src={WorldMap} />;
}
